import { createSlice, current } from "@reduxjs/toolkit";
import SelectOptionForDataset from "../../pages/datasets/createdataset/formsteps/selectoptionfordatasetstep";
import CreateFromDbStep from "../../pages/datasets/createdataset/formsteps/createfromdbstep";
import CreateDatasetFromFile from "../../pages/datasets/createdataset/formsteps/createfromfilestep";
import ChooseTable from "../../pages/datasets/createdataset/formsteps/choosetablestep";
import DatasetFile from "../../pages/datasets/createdataset/formsteps/datasetfileform";
import Result from "../../pages/datasets/createdataset/formsteps/result";
import ReviewStep from "../../pages/datasets/createdataset/formsteps/reviewstep";
import { api, axiosInstance } from "../../api/httpclient";
import { SITE_API_URL } from "../../settings";
import axios from "axios";
import { addNotification } from "./notificationsslice";
import { notificationDurationMiddle } from "../../lib/utils";
import i18next from "i18next";

export const stepFilePages = [
  SelectOptionForDataset,
  CreateDatasetFromFile,
  DatasetFile,
  ReviewStep,
  Result,
];

export const stepDbPages = [
  SelectOptionForDataset,
  CreateFromDbStep,
  ChooseTable,
  DatasetFile,
  ReviewStep,
  Result,
];


export const databaseDDL = [
  { Id: 1, Title: "Azure SQL" },
  { Id: 2, Title: "SQL Server" },
  { Id: 3, Title: "MySQL" },
  { Id: 4, Title: "Oracle" },
  { Id: 5, Title: "PstogreSQL" },
];

export const timeIntervalsDDL = [
  { Id: 0, Title: i18next.t("slices.none") },
  { Id: 5, Title: i18next.t("slices.fiveMins") },
  { Id: 10, Title: i18next.t("slices.tenMins") },
  { Id: 15, Title: i18next.t("slices.fiveteenMins") },
  { Id: 30, Title: i18next.t("slices.thirtyMins")},
  { Id: 60, Title: i18next.t("slices.oneHour")},
  { Id: 120, Title: i18next.t("slices.twoHours")},
  { Id: 180, Title: i18next.t("slices.threeHours")},
  { Id: 240, Title: i18next.t("slices.fourHours")},
  { Id: 300, Title: i18next.t("slices.fiveHours")},
  { Id: 360, Title: i18next.t("slices.sixHours")},
  { Id: 720, Title: i18next.t("slices.twelveHours")},
  { Id: 1440, Title: i18next.t("slices.oneDay")},
  { Id: 2880, Title: i18next.t("slices.twoDays")},
  { Id: 4320, Title: i18next.t("slices.threeDays")},
];

export const maxSize = 20 * 1024 * 1024 * 1024; //20GB

const defaultFormInitialValues = {
  //common
  CreateFrom: "fromfile",

  //file
  File: null,
  Filename: "",
  FileId: "",
  SelectedSheet: "",
  IsCheckedImportData: false,
  StartingRow: 2,
  EndingRow: null,
  IsDataReal: true,

  //database
  DatabaseType: 2,
  Server: "",
  Database: "",
  Username: "",
  Password: "",

  //table
  Table: "",

  //dataset
  DatasetName: "",
  DatasetTitle: "",
  DatasetDescription: "",
  DatasetIsAlertBase: false,
  DatasetImportData: true,
  DatasetIsReccurent: false,
  DatasetReccursEvery: 0,
  DatasetShowAlertBase: false,
  DatasetImportedRows: 10,
  DatasetFields: [],
  DatasetSampleData: [],
  DatasetLookupTextColumn: [{ Id: "Select", Title: i18next.t("slices.select") }],
  DatasetLookupTables: [{ Id: 0, Title: i18next.t("slices.select") }],
  GeneralOpen: true,
  FieldsOpen: true,
  DataSampleOpen: false,
  DatasetEditRowId: null,
  NumberOfRows: 0,
  DataSize: 0,
  RestOfConsumption: 0,
};

const initialState = {
  pageLoaded: false,
  pageDisposed: true,
  processing: false,
  processingText: "",
  mode: 1,

  currentStepIndex: 0,
  previousStepIndex: -1,
  previousStepValue: "Cancel",
  nextStepIndex: 1,
  nextStepValue: "Next",
  steps: [],
  stepPages: stepFilePages,
  stepperOrientation: "horizontal",
  sheets: [],
  lst_of_tables: [],

  formKey: new Date().toString(),
  formInitialValues: { ...defaultFormInitialValues },
  formValues: { ...defaultFormInitialValues },
  formClientErrors: {},
  formServerErrors: [],

  resultApiUrl: "",
  resultDatasetId: 0,
  resultInsertedRows: 0,
  resultMessage: "",

  toolsVisible: true,
  panes: [
    {
      // size: "30%",
      size: "20%",
      min: "20%",
      max: "25%",
      collapsible: false,
    },
    {
      //min: "700px",
      //size:"60%",
      min: "70%",
      max: "80%",
      collapsible: false,
    },
  ],

  //errors
  error_lst: [],
};

const createDatasetPageSlice = createSlice({
  name: "createDatasetPage",
  initialState: initialState,
  reducers: {
    setInitialState: (state, action) => ({ ...initialState }),

    setProcessing: (state, action) => {
      const { processing = true, processingText = "" } = action.payload;
      return {
        ...state,
        processing: processing,
        processingText: processing == false ? "" : processingText,
      };
    },
    setPanes: (state, action) => ({ ...state, panes: { ...action.payload } }),

    setPageValue: (state, action) => ({
      ...state,
      [action.payload.id]: action.payload.value,
    }),

    setFormValue: (state, action) => {
      let id = action.payload.id;
      let value = action.payload.value;
      let regex = action.payload.regex;
      let regexPattern = null;
      if (regex) {
        const match = regex.match(/^\/(.*?)\/([gimsuy]*)$/);
        if (match) {
          regexPattern = new RegExp(match[1], match[2]);
        }
      }
      return {
        ...state,
        formValues: {
          ...state.formValues,
          [id]: value && regexPattern ? value.replace(regexPattern, "") : value,
        },
      };
    },

    pageLoaded: (state, action) => {
      //payload: {reports: , currentUser: ,... }
      const pageState = current(state);

      if (pageState.pageDisposed) return state;

      return {
        ...state,
        pageLoaded: true,
        processing: false,
        processingText: "",
        pageDisposed: false,
      };
    },

    disposePage: (state, action) => {
      //payload: bool
      if (action.payload) return { ...initialState };
      else return { ...state, pageDisposed: false };
    },

    setCurrentStepIndex: (state, action) => {
      return {
        ...state,
        currentStepIndex: action.payload,
      };
    },

    setSteps: (state, action) => {
      return {
        ...state,
        steps: action.payload,
      };
    },

    setStepPages: (state, action) => {
      return {
        ...state,
        stepPages: action.payload,
      };
    },

    setNavigation: (state, action) => {
      const {
        previousStepIndex = -1,
        previousStepValue = "Cancel",
        nextStepIndex = 1,
        nextStepValue = "Next",
      } = action.payload;
      return {
        ...state,
        previousStepIndex: previousStepIndex,
        previousStepValue: previousStepValue,
        nextStepIndex: nextStepIndex,
        nextStepValue: nextStepValue,
      };
    },

    setSheets: (state, action) => {
      return {
        ...state,
        sheets: action.payload,
      };
    },

    setListOfTables: (state, action) => {
      return {
        ...state,
        lst_of_tables: action.payload,
      };
    },

    setFieldProperty(state, action) {
      const { id, prop, value } = action.payload;
      return {
        ...state,
        formValues: {
          ...state.formValues,
          DatasetFields: state.formValues.DatasetFields.map((field) =>
            field.Id === id ? { ...field, [prop]: value } : field
          ),
        },
      };
    },
    resetLookupTable(state, action) {
      console.log("resetLookupTable", action.payload);
      return {
        ...state,
        formValues: {
          ...state.formValues,
          DatasetFields: state.formValues.DatasetFields.map((field) =>
            field.Id === action.payload
              ? { ...field, LookupTableId: "0", LookupTableTitle: "" }
              : field
          ),
        },
      };
    },
    resetFileInfo(state, action) {
      return {
        ...state,
        formValues: {
          ...state.formValues,
          File: null,
          Filename: "",
          FileId: "",
          SelectedSheet: "",
          IsCheckedImportData: false,
          StartingRow: 2,
          EndingRow: null,
          IsDataReal: true,
        },
      };
    },
    resetDatabaseInfo(state, action) {
      return {
        ...state,
        formValues: {
          ...state.formValues,
          DatabaseType: 2,
          Server: "",
          Database: "",
          Username: "",
          Password: "",
          SelectedTableId: 0,
        },
      };
    },
    resetDatasetInfo(state, action) {
      return {
        ...state,
        formValues: {
          ...state.formValues,
          DatasetName: "",
          DatasetTitle: "",
          DatasetDescription: "",
          DatasetIsAlertBase: false,
          DatasetShowAlertBase: false,
          DatasetFields: [],
          DatasetSampleData: [],
          DatasetLookupTextColumn: [
            { Id: "Country", Title: i18next.t("slices.country") },
            { Id: "Operator", Title: i18next.t("slices.operator")},
          ],
          DatasetLookupTables: [
            { Id: 0, Title: i18next.t("slices.select")},
            { Id: 1, Title: i18next.t("slices.countries") },
            { Id: 2, Title: i18next.t("slices.operators")},
            { Id: 3, Title: i18next.t("slices.services") },
          ],
          GeneralOpen: true,
          FieldsOpen: true,
          DataSampleOpen: false,
          DatasetEditRowId: null,
        },
      };
    },
    resetDatabaseTableInfo(state, action) {
      return {
        ...state,
        formValues: {
          ...state.formValues,
          Table: "",
        },
      };
    },
  },
});

export default createDatasetPageSlice.reducer;

export const loadPage = (currentUser, t) => async (dispatch, getState) => {
  //start with initial values
  dispatch(setInitialState());

  //undispose page
  dispatch(disposePage(false));

  //show loader
  dispatch(
    setProcessing({ processing: true, processingText: t("slices.loadingPage") })
  );
  const fromFileSteps = [
    { label: t("datasets.create.from"), isValid: true },
    { label: t("datasets.create.choosefile"), isValid: undefined },
    { label: t("datasets.create.dataset"), isValid: undefined },
    { label: t("datasets.create.review"), isValid: undefined },
    { label: t("datasets.create.result"), isValid: undefined },
  ];
  dispatch(setPageValue({ id: "steps", value: fromFileSteps }));

  dispatch(pageLoaded({ currentUser: currentUser }));
};

export const getExcelSheetsFromFile =
  (formData, currentUser, t) => async (dispatch, getState) => {
    //show loader
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingPage") })
    );
    try {
      //const response = await axiosInstance.post('/DataSet/getexcelsheetsfromfile', formData);

      // const response = await api({
      //   url: "dataset/getexcelsheetsfromfile",
      //   method: "post",
      //   headers: { headers: { "Content-Type": "multipart/form-data" } },
      //   data: {
      //     File: file,
      //   },
      // });

      // Prepare the Authorization header
      let headers = {};
      if (currentUser.IsAuthenticated && currentUser.Jwt) {
        headers["Authorization"] = `bearer ${currentUser.Jwt}`;
      }

      const res = await fetch(
        `${SITE_API_URL}/DataSet/getexcelsheetsfromfile`,
        {
          method: "POST",
          headers: headers, // Set the headers
          body: formData,
        }
      );

      const response = await res.json();

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().createDatasetPage.pageDisposed) return;

      if (response.Errors?.length > 0) {
        dispatch(
          addNotification({
            text: response.Errors[0].Message,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
        dispatch(setProcessing({ processing: false, processingText: "" }));
        return;
      }

      //it's ok to dispatch here
      let data = response.Data;

      //transform the response
      dispatch(setSheets(data.SheetNames));
      dispatch(setFormValue({ id: "FileId", value: data.FileId }));
      dispatch(setProcessing({ processing: false, processingText: "" }));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      if (err.data.Errors?.length > 0) {
        dispatch(
          addNotification({
            text: err.data.Errors[0].Message,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
        dispatch(setProcessing({ processing: false, processingText: "" }));
      }
      return Promise.reject(err);
    }
  };

export const getDatasetSchemefromFile =
  (fileId, sheetname, importData, isDataReal, startingRow, endingRow, t) =>
  async (dispatch, getState) => {
    //show loading
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingDataset") })
    );

    try {
      var response = await api({
        url: "dataset/getdatasetschemefromfile",
        method: "post",
        data: {
          FileId: fileId,
          SheetName: sheetname,
          ImportData: importData,
          IsDataReal: isDataReal,
          StartingRow: startingRow,
          EndingRow: endingRow,
        },
        //headers:{'h':'1'}
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().createDatasetPage.pageDisposed) return;

      let data = response.data.Data;

      dispatch(setFormValue({ id: "DatasetFields", value: data.Fields }));
      dispatch(
        setFormValue({ id: "DatasetSampleData", value: data.SampleData })
      );
      dispatch(setFormValue({ id: "NumberOfRows", value: data.NumberOfRows }));

      dispatch(setProcessing({ processing: false, processingText: "" }));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false

      if (err.data.Errors?.length > 0) {
        dispatch(
          addNotification({
            text: err.data.Errors[0].Message,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
        dispatch(setProcessing({ processing: false, processingText: "" }));
      }
      return Promise.reject(err);
    }
  };

export const getTablesFromDbConnection =
  (dataBaseTypeId, server, dataBase, username, password, t) =>
  async (dispatch, getState) => {
    //show loading
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingDataset")})
    );

    try {
      var response = await api({
        url: "dataset/gettablesfromdbconnection",
        method: "post",
        data: {
          dataBaseTypeId: dataBaseTypeId,
          server: server,
          dataBase: dataBase,
          username: username,
          password: password,
        },
        //headers:{'h':'1'}
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().createDatasetPage.pageDisposed) return;

      let data = response.data.Data;

      dispatch(setListOfTables(data.Tables));
      dispatch(setProcessing({ processing: false, processingText: "" }));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      if (err.data.Errors?.length > 0) {
        dispatch(
          addNotification({
            text: err.data.Errors[0].Message,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
        dispatch(setProcessing({ processing: false, processingText: "" }));
      }
      return Promise.reject(err);
    }
  };

export const getDatasetSchemeFromDbConnection =
  (table, dataBaseTypeId, server, dataBase, username, password, t) =>
  async (dispatch, getState) => {
    //show loading
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingDataset")})
    );

    try {
      var response = await api({
        url: "dataset/getdatasetschemefromdbconnection",
        method: "post",
        data: {
          tableName: table,
          dataBaseConnection: {
            dataBaseTypeId: dataBaseTypeId,
            server: server,
            dataBase: dataBase,
            username: username,
            password: password,
          },
        },
        //headers:{'h':'1'}
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().createDatasetPage.pageDisposed) return;

      let data = response.data.Data;

      dispatch(setFormValue({ id: "DatasetFields", value: data.Fields }));
      dispatch(
        setFormValue({ id: "DatasetSampleData", value: data.SampleData })
      );
      dispatch(setFormValue({ id: "NumberOfRows", value: data.NumberOfRows }));
      dispatch(setFormValue({ id: "DataSize", value: data.DataSize }));
      dispatch(
        setFormValue({ id: "RestOfConsumption", value: data.RestOfConsumption })
      );

      dispatch(setProcessing({ processing: false, processingText: "" }));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      if (err.data.Errors?.length > 0) {
        dispatch(
          addNotification({
            text: err.data.Errors[0].Message,
            type: "error",
            closable: true,
            duration: notificationDurationMiddle,
            position: "topRight",
          })
        );
        dispatch(setProcessing({ processing: false, processingText: "" }));
      }
      return Promise.reject(err);
    }
  };

export const createDatasetFromDbConnection =
  (
    name,
    title,
    description,
    isAlertBase,
    table,
    importData,
    recurrsEvery,
    fields,
    dataBaseTypeId,
    server,
    dataBase,
    username,
    password,
    t
  ) =>
  async (dispatch, getState) => {
    //show loading
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingDataset")})
    );
    try {
      var response = await api({
        url: "dataset/createDatasetFromDbConnection",
        method: "post",
        data: {
          name: name,
          title: title,
          description: description,
          isAlertBase: isAlertBase,
          importData: importData,
          tableName: table,
          fields: fields,
          recurrsEvery: recurrsEvery,
          dataBaseConnection: {
            dataBaseTypeId: dataBaseTypeId,
            server: server,
            dataBase: dataBase,
            username: username,
            password: password,
          },
        },
        //headers:{'h':'1'}
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().createDatasetPage.pageDisposed) return;

      let data = response.data.Data;
      // if (data.Errors?.length > 0) {
      //   dispatch(
      //     addNotification({
      //       text: response.Errors[0].Message,
      //       type: "error",
      //       closable: true,
      //       duration: notificationDurationMiddle,
      //       position: "topRight",
      //     })
      //   );
      //   dispatch(setProcessing({ processing: false, processingText: "" }));
      //   return;
      // }
      if (response.data.Succeeded) {
        dispatch(setPageValue({ id: "resultApiUrl", value: data.ApiUrl }));
        dispatch(
          setPageValue({ id: "resultInsertedRows", value: data.InsertedRows })
        );
        dispatch(
          setPageValue({ id: "resultDatasetId", value: data.DatasetId })
        );
        dispatch(
          setPageValue({
            id: "resultMessage",
            value: t("slices.datasetUploaded"),
          })
        );
      }
      dispatch(setProcessing({ processing: false, processingText: "" }));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      // if (err.data.Errors?.length > 0) {
      //   dispatch(
      //     addNotification({
      //       text: err.data.Errors[0].Message,
      //       type: "error",
      //       closable: true,
      //       duration: notificationDurationMiddle,
      //       position: "topRight",
      //     })
      //   );
      //   dispatch(setProcessing({ processing: false, processingText: "" }));
      // }
      return Promise.reject(err);
    }
  };

export const createDatasetFromFile =
  (
    fileid,
    name,
    title,
    description,
    isAlertBase,
    importData,
    isDataReal,
    startingRow,
    endingRow,
    sheetname,
    fields,
    t
  ) =>
  async (dispatch, getState) => {
    //show loading
    dispatch(
      setProcessing({ processing: true, processingText: t("slices.loadingDataset") })
    );
    try {
      var response = await api({
        url: "dataset/createDatasetFromFile",
        method: "post",
        data: {
          fileId: fileid,
          name: name,
          title: title,
          description: description,
          isAlertBase: isAlertBase,
          importData: importData,
          isDataReal: isDataReal,
          startingRow: startingRow,
          endingRow: endingRow,
          sheetname: sheetname,
          fields: fields,
        },
        //headers:{'h':'1'}
      });

      //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
      if (getState().createDatasetPage.pageDisposed) return;
      let data = response.data.Data;

      // if (data.Errors?.length > 0) {
      //   dispatch(
      //     addNotification({
      //       text: response.Errors[0].Message,
      //       type: "error",
      //       closable: true,
      //       duration: notificationDurationMiddle,
      //       position: "topRight",
      //     })
      //   );
      //   dispatch(setProcessing({ processing: false, processingText: "" }));
      //   return;
      // }

      if (response.data.Succeeded) {
        dispatch(setPageValue({ id: "resultApiUrl", value: data.ApiUrl }));
        dispatch(
          setPageValue({ id: "resultInsertedRows", value: data.InsertedRows })
        );
        dispatch(
          setPageValue({ id: "resultDatasetId", value: data.DatasetId })
        );
        dispatch(
          setPageValue({
            id: "resultMessage",
            value: t("slices.datasetUploaded"),
          })
        );
      }
      dispatch(setProcessing({ processing: false, processingText: "" }));

      return Promise.resolve(response);
    } catch (err) {
      //i am here => could be any error included 200 and Succeeded=false
      // if (err.data.Errors?.length > 0) {
      //   dispatch(
      //     addNotification({
      //       text: err.data.Errors[0].Message,
      //       type: "error",
      //       closable: true,
      //       duration: notificationDurationMiddle,
      //       position: "topRight",
      //     })
      //   );
      //   dispatch(setProcessing({ processing: false, processingText: "" }));
      //   return;
      // }
      return Promise.reject(err);
    }
  };

export const getUserDefinedLookupList = (t) => async (dispatch, getState) => {
  //show loading
  dispatch(
    setProcessing({ processing: true, processingText: t("slices.loadingDataset") })
  );

  try {
    var response = await api({
      url: "dataset/getuserdefinedlookuplist",
      method: "post",

      //headers:{'h':'1'}
    });

    //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
    if (getState().createDatasetPage.pageDisposed) return;

    let data = response.data.Data;

    let lookupTablesArr = [
      { Id: 0, Title: t("slices.select") },
      { Id: -1, Title: t("slices.new") },
    ];

    data.Lookups.forEach((item) => {
      lookupTablesArr.push({ Id: item.Id, Title: item.Title });
    });

    dispatch(
      setFormValue({ id: "DatasetLookupTables", value: lookupTablesArr })
    );

    dispatch(setProcessing({ processing: false, processingText: "" }));

    return Promise.resolve(response);
  } catch (err) {
    //i am here => could be any error included 200 and Succeeded=false
    if (err.data.Errors?.length > 0) {
      dispatch(
        addNotification({
          text: err.data.Errors[0].Message,
          type: "error",
          closable: true,
          duration: notificationDurationMiddle,
          position: "topRight",
        })
      );
      dispatch(setProcessing({ processing: false, processingText: "" }));
    }
    return Promise.reject(err);
  }
};

export const {
  setInitialState,
  setProcessing,
  setPageValue,
  setPanes,
  pageLoaded,
  setFormValue,
  createEntity,
  entityLoaded,
  entityInserted,
  entityUpdated,
  entityCloned,
  entityDeleted,
  disposePage,
  setCurrentStepIndex,
  setSteps,
  setStepPages,
  setSheets,
  setListOfTables,
  setFieldProperty,
  setNavigation,
  resetLookupTable,
  resetFileInfo,
  resetDatabaseInfo,
  resetDatasetInfo,
  resetDatabaseTableInfo,
} = createDatasetPageSlice.actions;
